import { css } from '@emotion/react';
import { p2r } from '../../styles/fonts';
import { ARTICLE_SIDE_INDENT } from '../../styles/vars';
import { colors, breakpoints } from '../../styles';

const { lightBlack, lightGray } = colors;

const styles = (backgroundColor = lightGray) => css`
  color: ${lightBlack};

  .head-adv-wrapper > div > div > div > span {
    display: none;
  }

  .hero-background {
    display: block;
    width: 100%;
    min-height: ${p2r(304)};
    background-color: ${backgroundColor};
  }

  .hero-background-logo {
    position: absolute;
    z-index: -1;
    display: block;
    width: 100%;
    min-height: ${p2r(304)};
    background-color: ${backgroundColor};
  }

  .article__hero-wrapper {
    padding-top: ${p2r(64)};
  }

  @media (max-width: ${breakpoints.tablet}px) {
    .article__hero-wrapper {
      padding-top: 0;
    }
  }

  @media (max-width: ${breakpoints.hugeMobile}px) {
    .hero-background .download-button-top {
      position: absolute;
      top: 33%;
      right: 50%;
      bottom: 0;
      left: 3%;
    }
  }

  @media (max-width: ${breakpoints.smallTablet}px) {
    .article__head {
      position: relative;
      display: flex;
      flex-direction: column;
    }

    .article__hero-wrapper {
      order: 1;
      margin-bottom: ${p2r(16)};
    }

    .article__small-logo {
      order: 2;
      max-width: 90%;
      margin: 0 0 0 ${ARTICLE_SIDE_INDENT};
    }
  }
`;

export default styles;
